// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import styled from '@emotion/styled';

import {
  BREAKPOINTS,
  disabledColor,
  getColWidthCalc,
  unit,
} from '@zego/theme';

import H3 from '@zego/components/atoms/H3';
import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';

import TickNoCircle from '@zego/static/svgs/TickNoCircle.svg';

const CriteriaListSection = ({ title, subtitle, criteria = [], footer }) => (
  <ContentContainer
    css={{
      backgroundColor: disabledColor(2),
      margin: '0 16px',
      borderRadius: '12px',
      [BREAKPOINTS.medium]: { margin: '0 auto' },
    }}
  >
    <View css={{ paddingTop: unit(6), paddingBottom: unit(3) }}>
      <H3
        css={{
          fontSize: 20,
          marginBottom: unit(2),
          textAlign: 'center',
          fontWeight: 500,
          [BREAKPOINTS.medium]: { marginBottom: unit(3), fontSize: 20 },
        }}
      >
        {title}
      </H3>
      {subtitle ? (
        <RegularText
          css={{
            color: disabledColor(7),
            textAlign: 'center',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: unit(4),
            [BREAKPOINTS.medium]: {
              width: getColWidthCalc(12, 20, 6),
            },
          }}
        >
          {subtitle}
        </RegularText>
      ) : null}
      <ul
        css={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          marginLeft: 'auto',
          marginRight: 'auto',
          [BREAKPOINTS.medium]: {
            flexDirection: 'row',
            width: getColWidthCalc(12, 20, 8),
            flexWrap: 'wrap',
          },
          [BREAKPOINTS.large]: {
            width: getColWidthCalc(12, 20, 9),
          },
        }}
      >
        {criteria.map((value, index) => (
          <CriteriaListItem key={index}>{value}</CriteriaListItem>
        ))}
      </ul>
      <Spacer height={unit(2)} />
      <RegularText
        css={{
          color: disabledColor(7),
          textAlign: 'center',
          fontSize: 12,
          fontWeight: 'normal',
          lineHeight: '16px',
        }}
      >
        {footer}
      </RegularText>
    </View>
  </ContentContainer>
);

export default CriteriaListSection;

const CriteriaListItem = styled('li')({
  position: 'relative',
  paddingTop: unit(1),
  paddingBottom: unit(1),
  listStyleType: 'none',
  lineHeight: '24px',
  paddingLeft: unit(3),
  paddingRight: unit(5),
  fontWeight: 400,
  ':before': {
    left: '-8px',
    top: '7px',
    position: 'absolute',
    content: '""',
    backgroundImage: `url(${TickNoCircle})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    marginRight: unit(2),
    width: 24,
    height: 24,
  },
  fontSize: 14,
  [BREAKPOINTS.medium]: { fontSize: 16 },
});
